// Payment failed — shown after Stripe cancel; auto-returns to landing.

import React, { useEffect, useState } from 'react';
import logoSrc from '../../assets/mywellfie-header-logo.png';
import './landing.css';

interface Props {
  onReturn: () => void;
  resetSeconds?: number;
}

const AdhocPaymentFailedStage: React.FC<Props> = ({ onReturn, resetSeconds = 3 }) => {
  const [remaining, setRemaining] = useState(resetSeconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining((r) => Math.max(0, r - 1));
    }, 1000);
    const timeout = setTimeout(onReturn, resetSeconds * 1000);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [onReturn, resetSeconds]);

  return (
    <div className="adhoc-landing" style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <nav>
        <div className="wrap">
          <div className="nav-logo">
            <img src={logoSrc} alt="MyWellfie" />
          </div>
        </div>
      </nav>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '48px 32px',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            background: '#FEF2F2',
            border: '1px solid #FECACA',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 32,
            marginBottom: 24,
          }}
        >
          ✕
        </div>
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 'clamp(1.75rem, 4vw, 2.25rem)',
            fontWeight: 700,
            color: 'var(--ink)',
            margin: '0 0 12px',
          }}
        >
          Payment failed
        </h1>
        <p style={{ color: 'var(--muted)', fontSize: 17, maxWidth: 400, margin: '0 0 32px', lineHeight: 1.6 }}>
          The payment was not completed. Returning to the home page in {remaining} second{remaining !== 1 ? 's' : ''}…
        </p>
        <button type="button" className="btn btn-ghost" onClick={onReturn}>
          Back to home now
        </button>
      </div>
    </div>
  );
};

export default AdhocPaymentFailedStage;
